export const CREATE_PACKAGE_SAME_CODE = {
    REQUEST: 'PACKAGE.CREATE_PACKAGE_SAME_CODE.REQUEST',
    SUCCESS: 'PACKAGE.CREATE_PACKAGE_SAME_CODE.SUCCESS',
    FAILED: 'PACKAGE.CREATE_PACKAGE_SAME_CODE.FAILED',
};

export const CLEAR_STATE = 'PACKAGE.CREATE_PACKAGE_SAME_CODE.CLEAR_STATE';
